module.exports = __webpack_public_path__ + "media/site_templates/www.concreting.company/images/splash-38f5222742e319403c55090f63dd7a04.jpg";